const initialState = {
    loading: false,
    data: [],
    error: null,
};

const statusesReducer = (state = initialState, action) => {
    switch (action.type) {
        case "STATUSES_PENDING":
            return {
                ...state,
                loading: true,
                error: null,
            };
        case "STATUSES_SUCCESS":
            return {
                ...state,
                data: action.payload,
                loading: false,
                error: null,
            };
        case "STATUSES_ERROR":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default statusesReducer;
